import CheckCircle from '@mui/icons-material/CheckCircle'
import AccessTimeOutlined from '@mui/icons-material/AccessTimeOutlined'
import SoupKitchen from '@mui/icons-material/SoupKitchen'
import Star from '@mui/icons-material/Star'
import SendIcon from '@mui/icons-material/Send'
import { Box, Grid, SxProps, Typography } from '@mui/material'
import DownloadingOutlined from '@mui/icons-material/DownloadingOutlined'
import { OrderLineKdsStatus } from 'models'
import { useTranslation } from 'react-i18next'
import BlockIcon from '@mui/icons-material/Block'
import { usePosContext } from 'views/Sale/contexts/PosProvider'
export function KitchenStatusIcon({
    kdsStatus,
    sx,
}: {
    kdsStatus?: OrderLineKdsStatus
    sx?: SxProps
}) {
    const { isKDSEnable } = usePosContext()
    if (!isKDSEnable) return null
    switch (kdsStatus) {
        case OrderLineKdsStatus.Unknown:
            return (
                <Star fontSize="small" sx={{ color: 'warning.main', ...sx }} />
            )
        case OrderLineKdsStatus.Sent:
            return (
                <SendIcon
                    fontSize="small"
                    sx={{ color: 'disabled.contrastText', ...sx }}
                />
            )
        case OrderLineKdsStatus.Cancelled:
            return (
                <BlockIcon
                    fontSize="small"
                    sx={{ color: 'disabled.main', ...sx }}
                />
            )
        case OrderLineKdsStatus.AwaitingPreparation:
            return (
                <AccessTimeOutlined
                    fontSize="small"
                    sx={{ color: 'warning.main', ...sx }}
                />
            )
        case OrderLineKdsStatus.InPreparation:
            return (
                <DownloadingOutlined
                    fontSize="small"
                    sx={{ color: 'info.main', ...sx }}
                />
            )
        case OrderLineKdsStatus.Finished:
            return (
                <CheckCircle
                    fontSize="small"
                    sx={{ color: 'primary.main', ...sx }}
                />
            )
        default:
            return <></>
    }
}

function KitchenStatusManual({
    noMargin = false,
    splitRowAtLg = false,
}: {
    noMargin?: boolean
    splitRowAtLg?: boolean
}) {
    const { t } = useTranslation()

    return (
        <Grid
            container
            mt={noMargin ? 0 : '5px'}
            mb={noMargin ? 0 : 1}
            justifyContent={'space-between'}
            sx={{
                backgroundColor: 'default.light',
            }}
        >
            <Grid item xs="auto">
                <Box
                    bgcolor={'info.main'}
                    px={1}
                    py="5px"
                    alignItems={'center'}
                    display={'flex'}
                >
                    <SoupKitchen
                        sx={{ mr: '5px', color: 'white' }}
                        fontSize="small"
                    />
                    <Typography
                        fontWeight={'bold'}
                        color="white"
                        variant="body2"
                    >
                        {t('table_sale_lookup.kitchen_status.title')}
                    </Typography>
                </Box>
            </Grid>
            <Grid
                item
                container
                xs={12}
                lg={splitRowAtLg ? 12 : undefined}
                xl
                justifyContent={'flex-end'}
                alignItems={'center'}
                mx={noMargin ? 0 : '5px'}
            >
                <Grid item>
                    <Box alignItems={'center'} display={'flex'} py="5px">
                        <KitchenStatusIcon
                            kdsStatus={OrderLineKdsStatus.Unknown}
                            sx={{ mr: '5px' }}
                        />
                        <Typography variant="body2">
                            {t(
                                'table_sale_lookup.kitchen_status.status.unknown',
                            )}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item>
                    <Box alignItems={'center'} display={'flex'} py="5px" pl={1}>
                        <KitchenStatusIcon
                            kdsStatus={OrderLineKdsStatus.Sent}
                            sx={{ mr: '5px' }}
                        />
                        <Typography variant="body2">
                            {t('table_sale_lookup.kitchen_status.status.sent')}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item>
                    <Box alignItems={'center'} display={'flex'} py="5px" pl={1}>
                        <KitchenStatusIcon
                            kdsStatus={OrderLineKdsStatus.AwaitingPreparation}
                            sx={{ mr: '5px' }}
                        />
                        <Typography variant="body2">
                            {t(
                                'table_sale_lookup.kitchen_status.status.awaiting_preparation',
                            )}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item>
                    <Box alignItems={'center'} display={'flex'} py="5px" pl={1}>
                        <KitchenStatusIcon
                            kdsStatus={OrderLineKdsStatus.InPreparation}
                            sx={{ mr: '5px' }}
                        />
                        <Typography variant="body2">
                            {t(
                                'table_sale_lookup.kitchen_status.status.in_preparation',
                            )}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item>
                    <Box alignItems={'center'} display={'flex'} py="5px" pl={1}>
                        <KitchenStatusIcon
                            kdsStatus={OrderLineKdsStatus.Finished}
                            sx={{ mr: '5px' }}
                        />
                        <Typography variant="body2">
                            {t(
                                'table_sale_lookup.kitchen_status.status.finished',
                            )}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item>
                    <Box alignItems={'center'} display={'flex'} py="5px" pl={1}>
                        <KitchenStatusIcon
                            kdsStatus={OrderLineKdsStatus.Cancelled}
                            sx={{ mr: '5px' }}
                        />
                        <Typography variant="body2">
                            {t(
                                'table_sale_lookup.kitchen_status.status.cancelled',
                            )}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default KitchenStatusManual
